module.exports = __webpack_public_path__ + "media/images/icons/filled/google-square-fead7bce2dbe4c895df034e84a211ff2.svg";